import { call, put, takeEvery, delay, select } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import { getLanguageData } from 'util/localeHelper'
import { ACTION_KEY_AUTH, AuthActions, Action, NotificationActionFunctions } from '../actions'
import { switchLanguage } from '../actions/hrdp-web/Setting'
import apiService from '../../services/apiService'
import jwtAuthService from '../../services/jwtAuthService'
import { intl } from 'util/IntlHelper'

function* watchRequestSMS(action: Action) {
  console.log('[SAGA] watch Login')
  const { area_code, phone_number, organization_identifier } = action.payload
  try {
    const data = yield call(apiService.auth.requestSMS, area_code, phone_number, organization_identifier)
    yield put(AuthActions.requestToken.success(data))
    yield put(
      // notification.sms_code.sent
      NotificationActionFunctions.enqueue({
        message: intl.formatMessage({ id: 'notification.sms_code.sent' }),
        type: 'success',
      }),
    )

    yield put(AuthActions.setTokenTimeer(90))

    // const { auth } = yield select()

    for (let i = 90; i >= 0; i--) {
      const { auth } = yield select()
      if (auth.smsTimer >= 0) {
        yield put(AuthActions.setTokenTimeer(i))
        yield delay(1000)
      }
    }
  } catch (error) {
    console.warn('[SAGA] request SMS', error)
    // const errorMessage =
    yield put(AuthActions.requestToken.failure(error))
    if (error?.code !== 'ERR100173') {
      yield put(
        NotificationActionFunctions.enqueue({
          message: error,
          type: 'error',
        }),
      )
    }
  }
}

function* watchVerifySMS(action: Action) {
  console.log('[SAGA] watch Login')
  const { areaCode, phone, sms } = action.payload
  try {
    const data = yield call(jwtAuthService.loginWithSMS, areaCode, phone, sms)
    yield put(AuthActions.setCurrentAuthUser(data))
    yield put(AuthActions.verifyToken.success(data))
    yield put(AuthActions.setTokenTimeer(-1))
    yield put(push('/'))
  } catch (error) {
    console.warn('[SAGA] Watch Login', error)
    yield put(AuthActions.verifyToken.failure(error.code))
    // yield put(
    //     NotificationActionFunctions.enqueue({
    //         message: error,
    //         type: 'error',
    //     }),
    // )
  }
}

function* requestRefreshToken(action: Action) {
  const token = jwtAuthService.getToken()
  if (!token) {
    yield put(AuthActions.refreshToken.failure('No stored token'))
  } else {
    const { refresh_token } = token
    try {
      const updatedToken = yield call(apiService.auth.refreshToken, refresh_token)
      const newToken = updatedToken[0]
      jwtAuthService.setSession(newToken)
      yield put(AuthActions.refreshToken.success(newToken))
    } catch (error) {
      yield put(AuthActions.refreshToken.failure(error))
      yield put(
        NotificationActionFunctions.enqueue({
          message: error,
          type: 'error',
        }),
      )
    }
  }
}

function* fetchProfile(action: Action) {
  try {
    const result = yield call(apiService.auth.getProfile)
    yield put(AuthActions.requestProfile.success(result[0]))
    const langCd = result[0]?.preferred_language
    if (langCd) {
      yield put(switchLanguage(getLanguageData(langCd)))
    }
  } catch (error) {
    yield put(AuthActions.requestProfile.failure(error))
    yield put(
      NotificationActionFunctions.enqueue({
        message: error,
        type: 'error',
      }),
    )
  }
}

export const authSagas = [
  takeEvery(ACTION_KEY_AUTH.GET_PROFILE.REQUEST, fetchProfile),
  takeEvery(ACTION_KEY_AUTH.REFRESH_TOKEN.REQUEST, requestRefreshToken),
  takeEvery(ACTION_KEY_AUTH.REQUEST_SMS.REQUEST, watchRequestSMS),
  takeEvery(ACTION_KEY_AUTH.VERIFY_SMS.REQUEST, watchVerifySMS),
]
